import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateAssetFeatureSaga } from "src/store/asset-features/saga";
import { AssetFeatureDetailDto } from "src/store/asset-features/type";
import * as Yup from "yup";
import { DataTypeDto, SectorDto } from "src/store/system/type";
import { getDataTypes, getSectors } from "src/store/system/saga";
import { AssetTypeDto } from "src/store/asset-types/type";
import { getAssetTypeListSaga } from "src/store/asset-types/saga";

const AssetFeaturesEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: AssetFeatureDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const [assettypes, setAssettypes] = useState<AssetTypeDto[]>([]);
  const [datatypes, setDatatypes] = useState<DataTypeDto[]>([]);
  const { t } = useTranslation();
  useEffect(() => {
    if (open) {
      dispatch(
        getDataTypes({
          payload: {
            onSuccess: (message, payload) => {
              setDatatypes(payload);
            },
            onError: () => {},
          },
        })
      );
      dispatch(
        getAssetTypeListSaga({
          payload: {
            onSuccess: (message, payload) => {
              setAssettypes(payload);
            },
            onError: () => {},
          },
        })
      );
    }
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("AssetFeatures.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          Name: data.Name,
          DataTypeId: data.DataTypeId,
          AssetTypeId: data.AssetTypeId,
          Translates: data.Translates.map((x) => {
            return { LanguageId: x.LanguageId, Name: x.Name };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            updateAssetFeatureSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          AssetTypeId: Yup.string().required(
            t("Validation.Required").toString()
          ),
          DataTypeId: Yup.number().required(
            t("Validation.Required").toString()
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("AssetFeature.Name").toString(),
          },
        ]}
        inputs={[
          {
            field: "AssetTypeId",
            label: t("AssetFeature.AssetType").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "Id",
              options: assettypes,
            },
          },
          {
            field: "DataTypeId",
            label: t("AssetFeature.DataType").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "EnumId",
              options: datatypes,
            },
          },
        ]}
      />
    </React.Fragment>
  );
};
export default AssetFeaturesEditForm;
